module.exports = __webpack_public_path__ + "static/media/prism.3984fce4.mp4";